const TeamsSCP = [
    { id: 0, name: "None", hide: true},
    { id: 1, name: "SCP"},
    { id: 2, name: "MTF Team"},
    { id: 3, name: "Chaos Team"},
    { id: 4, name: "Other"},
]

export default TeamsSCP;